/**
 * 业务状态码
 */
export const enum BizCode {
  /**
   * 成功
   * @type {String}
   */
  SUCCESS = '0000',
  /**
   * 未授权
   * @type {String}
   */
  UNAUTHORIZED = '0001',
  /**
   * 需要验证码
   */
  NEED_CAPTCHA = '0003',
  /**
   * 身份证示例浮层
   */
  ID_CARD_EXAMPLES = '5000',
  /**
   * 识别失败去下载APP
   */
  DOWNLOAD_APP = '5001',
  /**
   * 资金源切换
   */
  FUND_PROVIDER_CHANGE = '0923',
  /**
   * 售罄
   */
  SELL_OUT = '9800',
}

/**
 * 品牌名称
 */
export const enum BrandTypes {
  YRXD = '宜人小贷',
  YXH = '宜享花',
}
